import React, { useState, useRef, useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as Fa from "react-icons/fa";
import Swal from 'sweetalert2';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import {
    FicComboBox,
    FicInput,
    FicTextArea,
    FicDatePicker,
    FicNumber,
} from "../../Utils/FormInputComponents/index";
import DialogModal from "../../components/DialogModal";
import "../../../../../style/autoVentas/VentasForm.css";
import GenBtn from "../../components/GenBtn";
import { validar } from "../../components/ValidarNit";
import { withRouter } from "react-router";
import styled, { keyframes } from "styled-components";
import LoadMask from "../../Utils/LoadMask/LoadMask";

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const Overlay = styled.div`
    font-size: 1.5rem;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    border-radius: 1rem;
    animation: ${({ isActive }) => (isActive ? fadeIn : fadeOut)} 0.3s
        ease-in-out forwards;
    pointer-events: ${({ isActive }) => (isActive ? "auto" : "none")};
    cursor: ${({ isActive }) => (isActive ? "default" : "initial")};
    z-index: 20;
`;

const DialogContent = styled.div`
    height: 205px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
`;

const TablaContainer = styled.div`
    margin-top: 20px;
    width: 100%;
    overflow-x: auto;
`;

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const schema = yup.object({
    carro: yup.mixed().required("La fecha es requerida"),
    fecha_venta: yup.string().required("La fecha es requerida"),
    vendedor: yup.mixed().required("El vendedor es requerido"),
    comprador_nombre: yup.string().required("El comprador es requerido"),
    comprador_dpi: yup
        .number()
        .typeError("Debe de ser un numero")
        .test("dpi-validation", "El dpi no es valido", function (value) {
            return validar.valCui(value.toString())[0].validar;
        })
        .required("El numero de dpi es requerido"),
    comprador_domicilio: yup.string().required("El domicilio es requerido"),
    comprador_departamento: yup
        .string()
        .required("El departamento es requerido"),
    comprador_profesion: yup.string().required("La profesion es requerida"),
    comprador_num_telefono: yup
        .number()
        .typeError("Debe de ser un numero")
        .required("El numero de telefono es requerido"),
    comprador_nit: yup
        .string()
        .test("dpi-validation", "El NIT no es valido", function (value) {
            return validar.valNit(value);
        })
        .required("El nit es requerido"),
    comprador_edad: yup
        .number()
        .positive("La edad debe ser mayor a 0")
        .typeError("Debe de ser un numero")
        .required("La edad es requerida"),
    comprador_estado_civil: yup
        .string()
        .required("El estado civil es requerido"),
    valor_venta: yup
        .number()
        .positive("El valor de venta debe ser mayor a 0")
        .typeError("Debe de ser un numero")
        .required("El valor de venta es requerido"),
});

function VendedoresForm(props) {
    const {
        crearVenta,
        datosDelIngreso,
        listadoDeIngresos,
        listarVendedores,
        reporteVentaDeVehiculos,
        history,
        listarPeriodos,
        listarCuentas,
        parametrosEmpresa,
        datos,
        loader,
        agregarLineaPoliza,
        lineasPoliza,
        eliminarLinea,
        limpiar
    } = props;

    const urlParams = props.match.params;
    const empresa = urlParams.empresa;
    const [ventaId, setVentaId] = useState("");
    const [loadingState, setLoadingState] = useState(false);
    const [fetchedValues, setFetchedValues] = useState(null);
    const [carroKey, setCarroKey] = useState(1);
    const [periodoKey, setPeriodoKey] = useState(0);
    const dialogRef = useRef(null);
    const [key, setKey] = useState('VENTA_TAB');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [crearVentaEstado, setCrearVentaEstado] = useState(true);

    const closeModal = useCallback(() => {
        resetModal({
            cuenta: { label: '', value: '' },
            debe: "0.00",
            haber: "0.00"
        });
        setIsModalOpen(false);
    }, []);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const defaultValues = {
        fecha_venta: null,
        vendedor: null,
        carro: null,
        comprador_nombre: "",
        comprador_dpi: "",
        comprador_domicilio: "",
        comprador_departamento: "",
        comprador_profesion: "",
        comprador_num_telefono: "",
        comprador_nit: "",
        comprador_edad: "",
        comprador_estado_civil: "",
        valor_venta: "",
        observaciones: "",
    };

    const {
        handleSubmit,
        reset,
        control,
        formState: {  },
        watch,
    } = useForm({
        mode: "all",
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
    });

    const {
        control: controlAutoData,
        formState: {  },
        reset: resetAutoData,
    } = useForm({
        mode: "all",
        defaultValues: {
            placa: "",
            codigo: "",
            tipo_carro: "",
            modelo: "",
            linea: "",
            numero_serie: "",
        },
        values: fetchedValues,
    });

    const modalForm = useForm({
        defaultValues: {
            cuenta: { label: '', value: '' },
            debe: "0.00",
            haber: "0.00"
        }
    });

    const { 
        handleSubmit: handleModalSubmit,
        control: controlModal,
        reset: resetModal
    } = modalForm;
    
    const carro = watch("carro");
    
    const fetchData = useCallback(async (ingresoId) => {
        setLoadingState(true);
        const formData = await datosDelIngreso(ingresoId);
        setFetchedValues(formData);
        setLoadingState(false);
    }, [datosDelIngreso]);

    useEffect(() => {
        if (carro) {
            fetchData(carro.value);
        }
        if (!carro) {
            resetAutoData({
                placa: "",
                codigo: "",
                tipo_carro: "",
                modelo: "",
                linea: "",
                numero_serie: "",
            });
        }
        parametrosEmpresa();
        limpiar();
    }, [carro, fetchData, resetAutoData]);

    const periodoPol = watch({ control, name: "periodo" });
    const fechaPol = watch({ control, name: "fecha_poliza" });

    const carroV = watch({ control, name: "carro" });
    const fechaV = watch({ control, name: "fecha_venta" });
    const vendedorV = watch({ control, name: "vendedor" });
    const compradorV = watch({ control, name: "comprador_nombre" });
    const compradorVD = watch({ control, name: "comprador_dpi" });
    const compradorDr = watch({ control, name: "comprador_domicilio" });
    const compradorDp = watch({ control, name: "comprador_departamento" });
    const compradorPr = watch({ control, name: "comprador_profesion" });
    const compradorTel = watch({ control, name: "comprador_num_telefono" });
    const compradorN = watch({ control, name: "comprador_nit" });
    const compradorE = watch({ control, name: "comprador_edad" });
    const compradorEC = watch({ control, name: "comprador_estado_civil" });
    const valor = watch({ control, name: "valor_venta" });
    const observacionesV = watch({ control, name: "observaciones" });

    const agregarLinea = useCallback(async (data) => {
        const datosCompletos = {
            ...data,
            periodo: periodoPol.periodo,
            fecha_poliza: fechaPol.fecha_poliza
        };
        await agregarLineaPoliza(datosCompletos);
        closeModal();
    }, [agregarLineaPoliza, closeModal, periodoPol, fechaPol]);

    const onSubmit = useCallback(async (data) => {
        if (datos.contabilidad === 'S'){
            const totalDebe = lineasPoliza.reduce((sum, linea) => sum + linea.debe, 0);
            const totalHaber = lineasPoliza.reduce((sum, linea) => sum + linea.haber, 0);
            let diferencia = Math.abs(totalDebe - totalHaber);

            if (lineasPoliza.length >= 1 && diferencia === 0) {
                const datoCompleto = {
                    ...data,  
                    lineasPoliza,
                    periodo: periodoPol.periodo,
                    fecha_poliza: fechaPol.fecha_poliza,
                    datos,
                    carro: carroV.carro,
                    fecha_venta: fechaV.fecha_venta,
                    vendedor: vendedorV.vendedor,
                    comprador_nombre: compradorV.comprador_nombre,
                    comprador_dpi: compradorVD.comprador_dpi,
                    comprador_domicilio: compradorDr.comprador_domicilio,
                    comprador_departamento: compradorDp.comprador_departamento,
                    comprador_profesion: compradorPr.comprador_profesion,
                    comprador_num_telefono: compradorTel.comprador_num_telefono,
                    comprador_nit: compradorN.comprador_nit,
                    comprador_edad: compradorE.comprador_edad,
                    comprador_estado_civil: compradorEC.comprador_estado_civil,
                    valor_venta: valor.valor_venta,
                    observaciones: observacionesV.observaciones
                }
                const resultado = await crearVenta(datoCompleto);
                if (resultado) {
                    setVentaId(resultado.id);
                    dialogRef.current.showModal();
                    
                    reset(defaultValues);
                    setCarroKey((a) => a + 1);
                    setPeriodoKey((b) => b + 1);
                    setCrearVentaEstado(true);
                    setKey('VENTA_TAB');
                    limpiar();
                }
            } else {
                Swal.fire({
                    title: 'Ventas',
                    text: 'La póliza debe estar cuadrada para finalizar la venta',
                    type: 'error',
                });
            }
        }else{
            const datoCompleto = {
                ...data,  
                datos,
                carro: carroV.carro,
                fecha_venta: fechaV.fecha_venta,
                vendedor: vendedorV.vendedor,
                comprador_nombre: compradorV.comprador_nombre,
                comprador_dpi: compradorVD.comprador_dpi,
                comprador_domicilio: compradorDr.comprador_domicilio,
                comprador_departamento: compradorDp.comprador_departamento,
                comprador_profesion: compradorPr.comprador_profesion,
                comprador_num_telefono: compradorTel.comprador_num_telefono,
                comprador_nit: compradorN.comprador_nit,
                comprador_edad: compradorE.comprador_edad,
                comprador_estado_civil: compradorEC.comprador_estado_civil,
                valor_venta: valor.valor_venta,
                observaciones: observacionesV.observaciones
            }
            const resultado = await crearVenta(datoCompleto);
            if (resultado) {
                setVentaId(resultado.id);
                dialogRef.current.showModal();
                
                reset(defaultValues);
                setCarroKey((a) => a + 1);
            }
        }
    }, [lineasPoliza, reset, defaultValues, carroV, fechaV, vendedorV, compradorV, compradorVD, compradorDr, compradorDp, compradorPr, compradorTel, compradorN, compradorE, compradorEC, valor, observacionesV ]);

    const disabled = false;

    // Calcular totales
    const totalDebe = lineasPoliza.reduce((sum, linea) => sum + linea.debe, 0);
    const totalHaber = lineasPoliza.reduce((sum, linea) => sum + linea.haber, 0);
    const diferenciaTotal = totalDebe - totalHaber;

    return (
        <React.Fragment>
            <br/>
            <div className="py-1">
                <div className="mb-1">
                    <div className="p-0 px-3 pt-0">
                    {(datos.contabilidad === 'S') &&
                        <form
                            encType="multipart/form-data"
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            <Tabs
                                destroyInactiveTabPane={true}
                                activeKey={key}
                                onChange={(k) => setKey(k)}
                                defaultActiveKey="PRINCIPAL_TOP"
                                tabBarPosition="top"
                                renderTabBar={() => <ScrollableInkTabBar />}
                                renderTabContent={() => <TabContent />}
                            >
                                <TabPane tab="Venta" key="VENTA_TAB">
                                    <div className="py-2 px-3">
                                        <div className="mb-4 text-white mb-1">
                                            <div className="p-0 pt-4 d-flex flex-column flex-md-row">
                                                <div className="d-flex flex-column flex-1 mx-4">
                                                    <h3
                                                        className="p-2  title rounded shadow"
                                                        style={{
                                                            background:
                                                                "linear-gradient(to top right, #790021, #2d2d2d)",
                                                        }}
                                                    >
                                                        Agregar Venta
                                                    </h3>
                                                    <br />
                                                    <div className="d-flex flex-row justify-content-start mb-2">
                                                        <GenBtn
                                                            BtnColor="#787878"
                                                            style={{ width: "100px", height: "40px" }}
                                                            onPress={(e) => {
                                                                history.push(`/auto_ventas/${empresa}/ventas`);
                                                            }}
                                                        >
                                                            Regresar
                                                        </GenBtn>
                                                    </div>
                                                    
                                                    <LoadMask loading={loadingState} color="#bd0034" blur={true}>
                                                        <div className="ventas-form__form-container">
                                                            <div style={{ color: "white" }}>DATOS DEL VEHÍCULO</div>
                                                            <div className="ventas-form__inputs-container">
                                                                <FicInput
                                                                    label="Placa"
                                                                    name="placa"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Código"
                                                                    name="codigo"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Tipo de carro"
                                                                    name="tipo_carro"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Modelo"
                                                                    name="modelo"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Línea"
                                                                    name="linea"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Número de serie"
                                                                    name="num_serie"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                                <FicInput
                                                                    label="Modalidad"
                                                                    name="modalidad"
                                                                    control={controlAutoData}
                                                                    isDisabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </LoadMask>

                                                    <LoadMask loading={loader} color="#bd0034" blur={true}>
                                                        <FicComboBox
                                                            key={carroKey}
                                                            componentStyle={{
                                                                marginTop: "15px",
                                                                marginBottom: "15px",
                                                            }}
                                                            control={control}
                                                            name="carro"
                                                            label="Carro"
                                                            loadOptions={listadoDeIngresos}
                                                        />
                                                        <div className="ventas-form__form-container">
                                                            <Overlay isActive={carro ? false : true}>
                                                                Seleccione un carro para continuar
                                                            </Overlay>
                                                            <div style={{ color: "white" }}>DATOS DE LA VENTA</div>
                                                            <div className="ventas-form__inputs-container">
                                                                <FicDatePicker
                                                                    control={control}
                                                                    name="fecha_venta"
                                                                    label="Fecha"
                                                                />
                                                                <FicComboBox
                                                                    componentStyle={{ zIndex: "3" }}
                                                                    control={control}
                                                                    name="vendedor"
                                                                    label="Vendedor"
                                                                    loadOptions={listarVendedores}
                                                                />
                                                                <FicInput
                                                                    label="Comprador"
                                                                    name="comprador_nombre"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Número de DPI"
                                                                    name="comprador_dpi"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Domicilio fiscal"
                                                                    name="comprador_domicilio"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Departamento"
                                                                    name="comprador_departamento"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Profesión u oficio"
                                                                    name="comprador_profesion"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Número de Teléfono"
                                                                    name="comprador_num_telefono"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="NIT"
                                                                    name="comprador_nit"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Edad"
                                                                    name="comprador_edad"
                                                                    control={control}
                                                                />
                                                                <FicInput
                                                                    label="Estado civil"
                                                                    name="comprador_estado_civil"
                                                                    control={control}
                                                                />
                                                                <FicNumber
                                                                    formatOptions={{
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                    }}
                                                                    label="Valor de venta"
                                                                    name="valor_venta"
                                                                    control={control}
                                                                />
                                                                <FicTextArea
                                                                    label="Observaciones"
                                                                    name="observaciones"
                                                                    control={control}
                                                                    style={{
                                                                        minHeight: "36.7px",
                                                                        gridColumn: "1/-1",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </LoadMask>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>

                                <TabPane tab="Póliza" key="POLIZA_TAB">
                                    <div className="py-2 px-3">
                                        <div className="mb-4 mb-3">
                                            <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                                                <div className="d-flex flex-column flex-1 mx-3">
                                                    <div className="ventas-form__form-container">
                                                        <Overlay isActive={carro ? false : true}>
                                                            Seleccione un carro para continuar
                                                        </Overlay>
                                                        <LoadMask loading={loader} color="#bd0034" blur={true}>
                                                            <div className="ventas-form__inputs-container">
                                                                <FicComboBox
                                                                    key={periodoKey}
                                                                    componentStyle={{ zIndex: "3" }}
                                                                    control={control}
                                                                    name="periodo"
                                                                    label="Periodo"
                                                                    loadOptions={listarPeriodos}
                                                                />
                                                                <FicDatePicker
                                                                    control={control}
                                                                    name="fecha_poliza"
                                                                    label="Fecha"
                                                                />
                                                            </div>
                                                        
                                                            {!disabled && (
                                                                <Contenido>
                                                                    <GenBtn
                                                                        onPress={openModal}
                                                                        BtnColor="#007bff"
                                                                        style={{ marginTop: "15px", marginBottom: "15px" }}
                                                                    >
                                                                        Agregar Línea
                                                                    </GenBtn>
                                                                </Contenido>
                                                            )}

                                                            <TablaContainer>
                                                                <Tabla>
                                                                    <thead>
                                                                        <tr>
                                                                            <TableHeader>Cuenta</TableHeader>
                                                                            <TableHeader>Debe</TableHeader>
                                                                            <TableHeader>Haber</TableHeader>
                                                                            <TableHeader>Acciones</TableHeader>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {(lineasPoliza || []).map((linea) => (
                                                                            <TableRow key={linea.id}>
                                                                                <TableCell>{linea.cuenta}</TableCell>
                                                                                <TableCell style={{ textAlign: 'right' }}>
                                                                                    {linea.debe.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell style={{ textAlign: 'right' }}>
                                                                                    {linea.haber.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <GenBtn
                                                                                        textColor="hsl(0, 100%, 50%)"
                                                                                        background="hsla(0, 100%, 50%, 0.2)"
                                                                                        title="Eliminar"
                                                                                        onPress={() => eliminarLinea(linea.id)}
                                                                                    >
                                                                                        <Fa.FaTrash />
                                                                                    </GenBtn>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                        {lineasPoliza.length > 0 && (
                                                                            <TableRow style={{ borderTop: '2px solid #ccc', fontWeight: 'bold' }}>
                                                                                <TableCell style={{ fontWeight: 'bold' }}>TOTAL</TableCell>
                                                                                <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                    {lineasPoliza.reduce((sum, linea) => sum + linea.debe, 0)
                                                                                        .toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                    {lineasPoliza.reduce((sum, linea) => sum + linea.haber, 0)
                                                                                        .toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell></TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                        {lineasPoliza.length === 0 && (
                                                                            <TableRow>
                                                                                <TableCell colSpan="4" style={{ textAlign: "center" }}>
                                                                                    No hay líneas agregadas
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </tbody>
                                                                </Tabla>
                                                                <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
                                                                    <div>
                                                                        {diferenciaTotal !== 0 && (
                                                                        <span style={{ color: "white" }}>
                                                                            Diferencia: {Math.abs(diferenciaTotal).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </TablaContainer>
                                                            <br />
                                                            <div className='d-flex flex-row mt-3'>
                                                                {crearVentaEstado && (
                                                                    <div>
                                                                        <GenBtn
                                                                            type="submit"
                                                                            className="ventas-form__guardar-ingreso-btn"
                                                                            style={{ marginTop: "15px" }}
                                                                        >
                                                                            Guardar Venta
                                                                        </GenBtn>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </LoadMask>
                                                    </div>
                                                    <br/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </form>
                    }
                    {(datos.contabilidad === 'N') &&
                    <form
                        encType="multipart/form-data"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <br />
                        <h3
                            className="p-2  title rounded shadow"
                            style={{
                                background:
                                    "linear-gradient(to top right, #790021, #2d2d2d)",
                            }}
                        >
                            Agregar Venta
                        </h3>
                        <br />
                        <div className="d-flex flex-row justify-content-start mb-2">
                            <GenBtn
                                BtnColor="#787878"
                                style={{ width: "100px", height: "40px" }}
                                onPress={(e) => {
                                    history.push(`/auto_ventas/${empresa}/ventas`);
                                }}
                            >
                                Regresar
                            </GenBtn>
                        </div>
                        <LoadMask loading={loadingState} color="#bd0034" blur={true}>
                            <div style={{ color: "white" }}>DATOS DEL VEHICULO</div>
                            <div className="ventas-form__inputs-container">
                                <FicInput
                                    label="Placa"
                                    name="placa"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                                <FicInput
                                    label="Codigo"
                                    name="codigo"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                                <FicInput
                                    label="Tipo de carro"
                                    name="tipo_carro"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                                <FicInput
                                    label="Modelo"
                                    name="modelo"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                                <FicInput
                                    label="Linea"
                                    name="linea"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
        
                                <FicInput
                                    label="Numero de serie"
                                    name="num_serie"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                                <FicInput
                                    label="Modalidad"
                                    name="modalidad"
                                    control={controlAutoData}
                                    isDisabled={true}
                                />
                            </div>
                        </LoadMask>
                        <LoadMask loading={loader} color="#bd0034" blur={true}>
                            <FicComboBox
                                key={carroKey}
                                componentStyle={{
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                }}
                                control={control}
                                name="carro"
                                label="Carro"
                                loadOptions={listadoDeIngresos}
                            />
                            <div className="ventas-form__form-container">
                                <Overlay isActive={carro ? false : true}>
                                    Seleccione un carro para continuar
                                </Overlay>
                                <div style={{ color: "white" }}>DATOS DE LA VENTA</div>
                                <div className="ventas-form__inputs-container">
                                    <FicDatePicker
                                        control={control}
                                        name="fecha_venta"
                                        label="Fecha"
                                    />
                                    <FicComboBox
                                        componentStyle={{ zIndex: "3" }}
                                        control={control}
                                        name="vendedor"
                                        label="Vendedor"
                                        loadOptions={listarVendedores}
                                    />
                                    <FicInput
                                        label="Comprador"
                                        name="comprador_nombre"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Numero de DPI"
                                        name="comprador_dpi"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Domicilio fiscal"
                                        name="comprador_domicilio"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Departamento"
                                        name="comprador_departamento"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Profesion u oficio"
                                        name="comprador_profesion"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Numero de Telefono"
                                        name="comprador_num_telefono"
                                        control={control}
                                    />
                                    <FicInput
                                        label="NIT"
                                        name="comprador_nit"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Edad"
                                        name="comprador_edad"
                                        control={control}
                                    />
                                    <FicInput
                                        label="Estado civil"
                                        name="comprador_estado_civil"
                                        control={control}
                                    />
                                    {/* <FicInput
                                        label="Valor de venta"
                                        name="valor_venta"
                                        type="number"
                                        control={control}
                                    /> */}
                                    <FicNumber
                                        formatOptions={{
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }}
                                        label="Valor de venta"
                                        name="valor_venta"
                                        control={control}
                                    />
        
                                    <FicTextArea
                                        label="Observaciones"
                                        name="observaciones"
                                        control={control}
                                        style={{
                                            minHeight: "36.7px",
                                            gridColumn: "1/-1",
                                        }}
                                    />
                                </div>
                                <br/>
                                <GenBtn
                                    type="submit"
                                    className="ventas-form__guardar-ingreso-btn"
                                    style={{ marginTop: "15px" }}
                                >
                                Guardar
                                </GenBtn>
                            </div>
                        </LoadMask>
                    </form>
                    }
                    </div>
                </div>
            </div>

            <DialogModal dialogRef={dialogRef} noHeader={true}>
                <DialogContent>
                    <div
                        style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "#bd0034",
                        }}
                    >
                        ¿Desea generar el finiquito?
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            marginTop: "15px",
                            width: "100%",
                        }}
                    >
                        <GenBtn
                            textColor="hsl(4, 100%, 39%)"
                            background="hsla(4, 100%, 39%, 0.2)"
                            onPress={() => {
                                dialogRef.current.close();
                            }}
                        >
                            Cerrar
                        </GenBtn>
                        <GenBtn
                            onPress={() => {
                                reporteVentaDeVehiculos(ventaId);
                                setTimeout(() => {
                                    dialogRef.current.close();
                                }, 3000);
                            }}
                            autofocus="autofocus"
                        >
                            Generar
                        </GenBtn>
                    </div>
                </DialogContent>
            </DialogModal>

            <ModalOverlay isOpen={isModalOpen}>
                <ModalContent>
                    <ModalHeader>
                        <ModalTitle>Ingresar detalle póliza</ModalTitle>
                        <CloseButton onClick={(e) => {
                            e.preventDefault(); 
                            closeModal();
                        }}>×</CloseButton>
                    </ModalHeader>
                    
                    <hr style={{ borderColor: "white", margin: "0 0 20px 0" }} />

                    <form onSubmit={handleModalSubmit(agregarLinea)}>
                        <ModalForm>
                            <div style={{ gridColumn: "1 / 3" }}>
                                <FicComboBox
                                    control={controlModal}
                                    name="cuenta"
                                    label="Cuenta contable..."
                                    loadOptions={listarCuentas}
                                    menuPlacement="top"
                                />
                            </div>
                        
                            <FicNumber
                                formatOptions={{
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }}
                                label="Debe"
                                name="debe"
                                control={controlModal}
                            />
                        
                            <FicNumber
                                formatOptions={{
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }}
                                label="Haber"
                                name="haber"
                                control={controlModal}
                            />
                        </ModalForm>
                        <ModalFooter>
                            <DiffText value={diferenciaTotal}>
                                Diferencia: {Math.abs(diferenciaTotal).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </DiffText>
                            <GenBtn
                                type="button"
                                BtnColor="#6c757d"
                                onPress={closeModal}
                            >
                                Cancelar
                            </GenBtn>
                            <GenBtn
                                type="submit"
                                BtnColor="#007bff"
                            >
                                Agregar
                            </GenBtn>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </ModalOverlay>
        </React.Fragment>
    );
}

export default withRouter(VendedoresForm);

const Tabla = styled.table`
    width: 100%;
    border-collapse: collapse;
    background-color: #333;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    color: #eee;
`;

const TableHeader = styled.th`
    padding: 12px 15px;
    text-align: left;
    background-color: #404040;
    border-bottom: 1px solid #555;
    font-weight: bold;
    color: #fff;
`;

const TableRow = styled.tr`
    &:nth-child(even) {
        background-color: #3a3a3a;
    }
    
    &.totals-row {
        background-color: #2d2d2d;
        color: #fff;
        font-weight: bold;
    }
`;

const TableCell = styled.td`
    padding: 12px 15px;
    border-bottom: 1px solid #555;
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: ${props => props.isOpen ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background-color: #2d2d2d;
    border-radius: 8px;
    padding: 20px;
    width: 80%;
    max-width: 900px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    color: #007bff;
`;

const ModalTitle = styled.h4`
    margin: 0;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #007bff;
    &:hover {
        color: #0056b3;
    }
`;

const ModalForm = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
`;

const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 10px;
`;

const DiffText = styled.div`
    margin-right: auto;
    color: white;
`;
